export default {
  createValueAddedActivity: '/valueAddedActivity/createValueAddedActivity',
  getValueAddedActivityAll: '/valueAddedActivity/getValueAddedActivityAll',
  getValueAddedActivityForFaculty: '/valueAddedActivity/getValueAddedActivityForFaculty',
  getValueAddedActivity: '/valueAddedActivity/getValueAddedActivity',
  updateValueAddedActivity: '/valueAddedActivity/updateValueAddedActivity',
  deleteValueAddedActivity: '/valueAddedActivity/deleteValueAddedActivity'
}
